import React from 'react';

export default () => (
  <>Unfortunately, you have reached a page that doesn't exist.</>
)